<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="设备编号" prop="device_id">
      <el-autocomplete v-fixZoom :disabled="!isBind" style="width: 100%" class="inline-input" v-model="addEditForm.device_id"
                       :fetch-suggestions="querySearch" placeholder="请输入设备编号" :trigger-on-focus="false" @select="handleSelect">
      </el-autocomplete>
    </el-form-item>
    <!--    v-if="isBindType === 1"-->
    <el-form-item v-if="isBindType === 1" label="绑定房间" prop="roomid">
      <el-input v-if="!isBind" disabled style="width: 100%" v-model="orgAddresss"></el-input>
      <el-cascader v-fixZoom v-else :disabled="!isBind" style="width: 100%" :options="roomOptions" v-model="addEditForm.roomid" :filterable="true" placeholder="请选择"
                   :props="{ checkStrictly: true, value: 'showId', label: 'name', children: 'child', emitPath: false, disabled: 'disabled', lazy: true, lazyLoad: lazyLoad}"
                   ref="roomOptions" @change="selectHid">
      </el-cascader>
    </el-form-item>
    <el-form-item v-if="isBindType === 1" label="安装位置">
      <el-input style="width: 100%" v-model="addEditForm.installlocation"></el-input>
    </el-form-item>
    <!--     v-if="isBindType === 2"-->
    <el-form-item v-if="isBindType === 2" label="绑定楼层" prop="orgid">
      <el-cascader v-fixZoom :disabled="!isBind" style="width: 100%" :options="orgOptions" v-model="addEditForm.orgid" :filterable="true" placeholder="请选择"
                   :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}" ref="orgOptions">
      </el-cascader>
    </el-form-item>
    <el-form-item v-if="isBindType === 2" label="安装位置">
      <el-input style="width: 100%" v-model="addEditForm.install_location"></el-input>
    </el-form-item>
    <!--     v-if="isBindType === 3"-->
    <!--    radioType  1、监护设备页面 - 老人绑定 2、员工设备页面 - 员工绑定-->
    <el-form-item v-if="radioType === 1 && isBindType === 3" label="所属老人" prop="pid">
      <el-select v-fixZoom :disabled="!isBind" v-model="addEditForm.pid" filterable placeholder="请选择" :clearable="true" style="width:100%;">
        <el-option v-for="item in elderly" :key="item.index" :label="item.name" :value="item.id">
          <span>{{ getSelectElderlyShow(item) }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="radioType === 2 && isBindType === 3" label="所属员工" prop="sp_id">
      <el-select v-fixZoom :disabled="!isBind" v-model="addEditForm.sp_id" filterable placeholder="请选择员工" style="width: 100%" @change="changeOrg">
        <el-option v-for="item in orgpersons" :key="item.value" :label="item.name" :value="item.id">
          <span style="float: left">{{ item.name }}</span>
          <span style="float: left; color: #8492a6; font-size: 12px" v-if="item.jobnum !== ''">&nbsp;-&nbsp;{{ item.jobnum }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <!--     v-if="isBindType === 4"-->
    <el-form-item v-if="isBindType === 4" label="绑定床位" prop="bid">
      <el-cascader v-fixZoom v-model="addEditForm.bid" placeholder="请选择" :props="optionProps" :show-all-levels="false" style="width: 100%"
                   ref="orgOptions" @change="changeNodes"></el-cascader>
    </el-form-item>
    <!--     v-if="isBindType === 5"-->
    <!-- 员工页面绑定850 852-->
    <el-form-item v-if="isBindType === 5" label="所属员工" prop="sp_id">
      <el-select v-fixZoom :disabled="!isBind" v-model="addEditForm.sp_id" filterable placeholder="请选择员工" style="width: 100%" @change="changeAcc">
        <el-option v-for="item in orgpersons" :key="item.value" :label="item.name" :value="item.id">
          <span style="float: left">{{ item.name }}</span>
          <span style="float: left; color: #8492a6; font-size: 12px" v-if="item.jobnum !== ''">&nbsp;-&nbsp;{{ item.jobnum }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="isBindType === 5" label="绑定账号" prop="sys_user_id">
      <el-select v-fixZoom :disabled="!isBind" v-model="addEditForm.sys_user_id" placeholder="请选择账号" style="width: 100%">
        <el-option v-for="item in showAcc" :key="item.value" :label="item.username" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>

    <div v-if="!(addEditForm.dtype === 601 || addEditForm.dtype === 602 || addEditForm.dtype === 612 || addEditForm.dtype === 613 || addEditForm.dtype === 406)">
      <el-form-item v-if="addEditForm.dtype === 700 || addEditForm.dtype === 701 || addEditForm.dtype === 537 || addEditForm.dtype === 850 || addEditForm.dtype === 851 || addEditForm.dtype === 852" label="设备号码">
        <el-input style="width: 100%" placeholder="请输入设备号码" v-model="addEditForm.phone" :disabled="isEdit" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item v-else label="设备号码" prop="phone">
        <el-input style="width: 100%" placeholder="请输入设备号码" v-model="addEditForm.phone" :disabled="isEdit" autocomplete="off"></el-input>
      </el-form-item>
    </div>
    <el-form-item v-if="radioType === 2 && !isBind" label="自动巡查" label-width="120px" prop="phone">
      <el-switch v-model="addEditForm.auto_patrol" active-color="#13ce66" inactive-color="#ff4949"
        :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭">
      </el-switch>
    </el-form-item>
  </el-form>
  <div style="margin-top: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAdd()"><span>取消</span></div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')"><span>确定</span></div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {
  binddevicetohome,
  binddevicetoperson,
  searchunbinddevice,
  updatedevicetohome,
  updatedevicetoperson
} from '../../../api/device'
import {binddevicenursing, editdevicenursing, queryhomebed, binddevicetosysuser} from '../../../api/yanglaoyuan'
import {queryChildrenOrgByEid, queryChildrenOrgByOrgId} from '../../../api/organizer'
import {queryOrgHomeByOrgId} from '../../../api/yanglaoyuan/orgHome'
import {queryuserbyspid} from '../../../api/account'

export default {
  name: 'addEditDeviceNew',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgOptions: [], // 楼层
      roomOptions: [], // 房间
      orgArrNew: [],
      roomArrNew: [],
      elderly: [], // 所属老人
      orgpersons: [], // 所属员工
      orgAddresss: '',
      addEditForm: {
        id: '',
        deviceid: '',
        orgid: '', // 4G拉绳报警器绑定到楼层
        did: '', // 设备id
        phone: '',
        hid: '', // 网关绑定房间
        roomid: '',
        bid: 0, // 床id
        installlocation: '',
        pid: '', // 绑定老人id
        sp_id: '', // 手表绑定员工id
        device_id: '',
        nonetwork: '0', // 手表离线报警
        install_location: '', // 4G拉绳报警器安装位置
        auto_patrol: 1, // 自动巡查
        dtype: '',
        sys_user_id: '' // 绑定账号
      },
      addEditRules: {
        device_id: [
          { required: true, message: '请输入设备编号', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入设备号码', trigger: 'blur' }
        ],
        orgid: [
          { required: true, message: '请选择楼层', trigger: 'change' }
        ],
        roomid: [
          { required: true, message: '请选择房间', trigger: 'change' }
        ],
        pid: [
          { required: true, message: '请选择所属老人', trigger: 'change' }
        ],
        sp_id: [
          { required: true, message: '请选择所属员工', trigger: 'change' }
        ],
        sys_user_id: [
          { required: true, message: '请选择绑定账号', trigger: 'change' }
        ]
      },
      radioType: 1, // 1、监护设备页面 - 老人绑定 2、员工设备页面 - 员工绑定
      isBindType: '',
      // 1、850/851 平板设备 / 700-网关 701-拉绳网关（房间）537-4G拉绳按钮（房间）504-NB门磁（房间 507-NB无线按钮（房间)，
      // 2、902-4G拉绳报警器绑定到楼层，
      // 3、300 310 311 312 313 330 351 352 353-手表可绑定到老人或者护工。
      // 4、601/602/612/613/406-UWB睡眠仪绑定到床位，
      // 5、850/852 平板设备绑员工或者账号
      isEdit: false, // 设备号码是否能修改
      isBind: true,
      optionProps: {
        value: 'id',
        label: 'name',
        lazy: true,
        emitPath: false,
        showAllLevels: true,
        lazyLoad: async (node, resolve) => {
          let nodes = []
          if (node.level === 0) {
            nodes = await this.getOrgData()
          } else if (node.data.org_type === 0 || node.data.org_type === 1) {
            nodes = await this.getOrgChildData(node.value)
          } else if (node.data.org_type === 2) {
            nodes = await this.getOrgHomeData(node.value)
          } else {
            nodes = await this.getHomeBedData(node.value)
          }
          resolve(nodes)
        }
      },
      showAcc: []
    }
  },
  created () {
    let dtypes = this.commonType.getWatchDtype()
    this.getRoomArr()
    // 700 701 网关绑定到房间、537 4G拉绳按钮绑定到房间、902 4G拉绳报警器绑定到楼层、300 310 351 352 353 311 312 313 330 手表可绑定到老人或者护工
    // console.log(this.addEditObj)
    this.orgOptions = this.addEditObj.orgData
    this.elderly = this.addEditObj.elderly
    this.orgpersons = this.addEditObj.orgpersons
    this.isBind = this.addEditObj.isBind
    this.radioType = this.addEditObj.radioType
    if (!this.isBind) {
      this.addEditForm.id = this.addEditObj.deviceRow.id
      this.addEditForm.did = this.addEditObj.deviceRow.id
      this.addEditForm.hid = this.addEditObj.deviceRow.hid
      this.addEditForm.roomid = this.addEditObj.deviceRow.hid
      this.addEditForm.deviceid = this.addEditObj.deviceRow.deviceid
      this.addEditForm.device_id = this.addEditObj.deviceRow.deviceid
      this.addEditForm.installlocation = this.addEditObj.deviceRow.h_installlocation
      this.addEditForm.pid = this.addEditObj.deviceRow.pid
      this.addEditForm.sp_id = this.addEditObj.deviceRow.sp_id
      this.addEditForm.dtype = this.addEditObj.deviceRow.devicetype
      this.orgAddresss = this.addEditObj.deviceRow.build_name + '/' + this.addEditObj.deviceRow.floor_name + '/' + this.addEditObj.deviceRow.home_room
      if (this.addEditObj.deviceRow.simcardno !== '') {
        this.isEdit = true
      }
      // this.isEdit = !(this.addEditObj.deviceRow.simcardno === '' || this.addEditObj.deviceRow.simcardno.length !== 11)
      if (this.addEditObj.deviceRow.devicetype === 851 || this.addEditObj.deviceRow.devicetype === 700 || this.addEditObj.deviceRow.devicetype === 701 ||
        this.addEditObj.deviceRow.devicetype === 537 || this.addEditObj.deviceRow.devicetype === 504 || this.addEditObj.deviceRow.devicetype === 507 ||
        this.addEditObj.deviceRow.devicetype === 405) {
        this.addEditForm.phone = this.addEditObj.deviceRow.simcardno === '' ? this.addEditObj.deviceRow.h_phone : this.addEditObj.deviceRow.simcardno
        this.addEditForm.orgid = 0
        this.addEditForm.sp_id = 0
        this.isBindType = 1
      } else if (this.addEditObj.deviceRow.devicetype === 850) {
        if (this.radioType === 1) {
          this.isBindType = 1
        } else if (this.radioType === 2) { // 暂不编辑
          this.isBindType = 5
        }
      } else if (this.addEditObj.deviceRow.devicetype === 852) { // 暂不编辑
        this.isBindType = 5
      } else if (this.addEditObj.deviceRow.devicetype === 902) {
        this.addEditForm.phone = this.addEditObj.deviceRow.simcardno === '' ? this.addEditObj.deviceRow.o_phone : this.addEditObj.deviceRow.simcardno
        this.addEditForm.orgid = this.addEditObj.deviceRow.oid
        this.addEditForm.install_location = this.addEditObj.deviceRow.o_installlocation
        this.isBindType = 2
      } else if (dtypes.indexOf(this.addEditObj.deviceRow.devicetype) > -1) { // 绑定人
        if (this.radioType === 1) {
          this.addEditForm.phone = this.addEditObj.deviceRow.simcardno === '' ? this.addEditObj.deviceRow.p_phone : this.addEditObj.deviceRow.simcardno
        } else if (this.radioType === 2) {
          this.addEditForm.phone = this.addEditObj.deviceRow.simcardno === '' ? this.addEditObj.deviceRow.sp_phone : this.addEditObj.deviceRow.simcardno
          this.addEditForm.auto_patrol = this.addEditObj.deviceRow.auto_patrol
        }
        this.isBindType = 3
      } else if (this.addEditObj.deviceRow.devicetype === 601 || this.addEditObj.deviceRow.devicetype === 602 ||
        this.addEditObj.deviceRow.devicetype === 612 || this.addEditObj.deviceRow.devicetype === 613 || this.addEditObj.deviceRow.devicetype === 406) { // 暂不编辑
        this.isBindType = 4
      }
    }
  },
  mounted () {
    // this.getRoomArr()
  },
  methods: {
    changeOrg (id) {
      console.log('==', id)
      for (let i = 0; i < this.orgpersons.length; i++) {
        if (id === this.orgpersons[i].id) {
          console.log(this.orgpersons[i])
          this.addEditForm.orgid = this.orgpersons[i].orgid
        }
      }
    },
    changeAcc (id) {
      console.log(id)
      this.showAcc = []
      this.addEditForm.aid = ''
      let data = {spid: id}
      queryuserbyspid(data).then(res => {
        this.showAcc = res.data.users
      }).catch(() => {})
      for (let i = 0; i < this.orgpersons.length; i++) {
        if (id === this.orgpersons[i].id) {
          this.addEditForm.orgid = this.orgpersons[i].orgid
        }
      }
      console.log(this.addEditForm.orgid)
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.room && item.room !== '' ? item.room + '号间' : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name + '号床' : '--'
      return elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },
    lazyLoad (node, resolve) {
      if (node.data.length === 0) {
        resolve(this.roomOptions)
        return
      }
      if (node.data.org_type === 0 || node.data.org_type === 1) {
        let arr = this.orgArrNew.filter(item => item.orgpid === node.data.id)
        if (arr.length > 0) {
          resolve(arr)
        } else {
          resolve([])
        }
      } else if (node.data.org_type === 2) {
        let arr = this.roomArrNew.filter(item => item.orgid === node.data.id)
        if (arr.length > 0) {
          resolve(arr)
        } else {
          resolve([])
        }
      } else {
        resolve([])
      }
    },
    getRoomArr () {
      let arr = []
      this.orgArrNew = []
      this.roomArrNew = []
      let orgArr = this.clone(this.addEditObj.orgArr)
      let roomArr = this.clone(this.addEditObj.roomArr)
      let showId = 1
      for (let i = 0; i < orgArr.length; i++) {
        let obj = orgArr[i]
        obj.disabled = true
        obj.showId = showId
        showId++
        arr.push(obj)
        this.orgArrNew.push(obj)
      }
      for (let i = 0; i < roomArr.length; i++) {
        let obj = roomArr[i]
        obj.disabled = false
        obj.showId = showId
        obj.orgpid = obj.orgid
        obj.name = obj.room
        showId++
        arr.push(obj)
        this.roomArrNew.push(obj)
      }
      // console.log(this.orgArrNew, this.roomArrNew)
      this.getRoomTree(this.orgArrNew) // 组织树
    },
    getRoomTree (arr) {
      // console.log('arr', arr)
      // 房间
      let lastLevel = 100
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      let treeData = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          treeData.push(arr[i])
        }
      }
      this.roomOptions = treeData
    },
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    handleSelect (item) {
      let dtypes = this.commonType.getWatchDtype()
      // console.log('item', item)
      this.addEditForm.did = item.id
      this.addEditForm.deviceid = item.deviceid
      this.addEditForm.phone = item.simcardno
      this.addEditForm.dtype = item.dtype
      if (dtypes.indexOf(item.dtype) > -1) { // 绑定人
        this.isBindType = 3 // 300 310 311 312 313 330 350 351 352 353、手表 901、随身通（人）
      } else if (item.dtype === 700 || item.dtype === 701 || item.dtype === 537 || item.dtype === 504 || item.dtype === 507 || item.dtype === 851 || item.dtype === 405) {
        this.isBindType = 1 // 700 701、网关（房间）|537 4G拉绳按钮（房间）| 504、NB门磁（房间）| 507、NB无线按钮（房间）| 850/851、平板设备（房间）| 405、wifi雷达（房间）
      } else if (item.dtype === 850) {
        if (this.radioType === 1) { // 监护设备页面
          this.isBindType = 1 // 850、平板设备（房间）
        } else if (this.radioType === 2) { // 员工设备页面
          this.isBindType = 5 // 852、绑员工或者账号
        }
      } else if (item.dtype === 852) {
        this.isBindType = 5 // 852、绑员工或者账号
      } else if (item.dtype === 902) {
        this.isBindType = 2 // 902、4G拉绳报警器（楼层）
      } else if (item.dtype === 601 || item.dtype === 602 || item.dtype === 612 || item.dtype === 613 || item.dtype === 406) { // UWB睡眠仪（主机设备）
        this.isBindType = 4 // 601/602/612/613/406、UWB睡眠仪/主机设备（绑定到床位）
      } else {
        this.isBindType = ''
      }
      if (item.simcardno === '' || item.simcardno.length !== 11) {
        this.isEdit = false
      } else {
        this.isEdit = true
      }
    },
    querySearch (queryString, cb) {
      if (queryString.length < 4) {
        let arr = []
        cb(arr)
        return
      }
      searchunbinddevice({lessdeviceid: queryString}).then(res => {
        let re = []
        for (let i = 0; i < res.data.devices.length; i++) {
          if (this.radioType === 2) { // 绑定对象 1、老人设备管理。2、员工设备管理
            if (res.data.devices[i].devicetype === 300 || res.data.devices[i].devicetype === 310 || res.data.devices[i].devicetype === 311 ||
              res.data.devices[i].devicetype === 312 || res.data.devices[i].devicetype === 313 || res.data.devices[i].devicetype === 330 ||
              res.data.devices[i].devicetype === 351 || res.data.devices[i].devicetype === 352 || res.data.devices[i].devicetype === 353 ||
              res.data.devices[i].devicetype === 850 || res.data.devices[i].devicetype === 852) {
              re.push({
                value: res.data.devices[i].deviceid + '(' + this.getDtype(res.data.devices[i].devicetype) + ')',
                deviceid: res.data.devices[i].deviceid,
                dtype: res.data.devices[i].devicetype,
                id: res.data.devices[i].id,
                simcardno: res.data.devices[i].simcardno
              })
            }
          } else {
            re.push({
              value: res.data.devices[i].deviceid + '(' + this.getDtype(res.data.devices[i].devicetype) + ')',
              deviceid: res.data.devices[i].deviceid,
              dtype: res.data.devices[i].devicetype,
              id: res.data.devices[i].id,
              simcardno: res.data.devices[i].simcardno
            })
          }
        }
        cb(re)
      }).catch(() => {
        let arr = []
        cb(arr)
      })
    },
    getDtype (type) {
      if (type === 700) {
        return '智能网关'
      }
      return this.commonType.getDeviceType(type)
    },
    selectHid () {
      let node = this.$refs.roomOptions.getCheckedNodes()
      // console.log(node, node[0].data)
      this.addEditForm.hid = node[0].data.id
    },
    // 树床位
    async getOrgData () {
      let arr = []
      let data = { eid: this.$store.state.user.LoginResp.entity_id }
      await queryChildrenOrgByEid(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgChildData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryChildrenOrgByOrgId(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgHomeData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryOrgHomeByOrgId(data).then(res => {
        if (res.data.orghomes) {
          res.data.orghomes.forEach(orgHome => {
            orgHome.leaf = false
            orgHome.name = orgHome.room
            arr.push(orgHome)
          })
        }
      })
      return arr
    },
    async getHomeBedData (id) {
      let arr = []
      let data = {
        hid: id
      }
      await queryhomebed(data).then(res => {
        if (res.data.homebed) {
          res.data.homebed.forEach(homeBed => {
            homeBed.leaf = true
            homeBed.name = homeBed.bed_name
            arr.push(homeBed)
          })
        }
      })
      console.log(arr)
      return arr
    },
    changeNodes () {
      let node = this.$refs.orgOptions.getCheckedNodes()
      this.addEditForm.hid = node[0].data.hid
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      // console.log(111, this.addEditForm)
      this.$refs[formName].validate((valid) => {
        // console.log(222, this.addEditForm)
        if (valid) {
          if (this.addEditForm.deviceid === '') {
            this.$message.info('暂无录入此设备或已绑定')
            return
          }
          // console.log(333, this.isBindType)
          if (this.isBindType === 1 || this.isBindType === 4) {
            // 850/851、平板设备（房间） 700/701、网关（房间）504、NB门磁（房间） 507、NB无线按钮（房间）
            // 601/602/612/613/406、UWB睡眠仪/主机设备（绑定到床位）
            let data = {
              did: this.addEditForm.did,
              hid: this.addEditForm.hid,
              deviceid: this.addEditForm.deviceid,
              phone: this.addEditForm.phone,
              installlocation: this.addEditForm.installlocation,
              dtype: this.addEditForm.dtype,
              bid: this.addEditForm.bid
            }
            if (this.isBind) {
              binddevicetohome(data).then(res => {
                this.$notify({ title: '成功', message: '成功绑定设备', type: 'success' })
                this.$emit('updateDevice')
                this.$emit('change', false)
              })
            } else {
              let data = {
                id: this.addEditForm.id,
                phone: this.addEditForm.phone,
                installlocation: this.addEditForm.installlocation
              }
              updatedevicetohome(data).then(res => {
                this.$notify({ title: '成功', message: '成功编辑设备', type: 'success' })
                this.$emit('updateDevice')
                this.$emit('change', false)
              })
            }
          } else if (this.isBindType === 2) {
            // 902 4G拉绳报警器 按照到楼层
            if (this.isBind) {
              let data = {
                did: this.addEditForm.did,
                orgid: this.addEditForm.orgid,
                sp_id: 0,
                deviceid: this.addEditForm.deviceid,
                phone: this.addEditForm.phone,
                install_location: this.addEditForm.install_location
              }
              binddevicenursing(data).then(res => {
                this.$notify({title: '成功', message: '成功绑定设备', type: 'success'})
                this.$emit('updateDevice')
                this.$emit('change', false)
              })
            } else {
              let data = {
                did: this.addEditForm.did,
                orgid: this.addEditForm.orgid,
                sp_id: 0,
                deviceid: this.addEditForm.deviceid,
                phone: this.addEditForm.phone,
                install_location: this.addEditForm.install_location
              }
              editdevicenursing(data).then(res => {
                this.$notify({title: '成功', message: '成功编辑设备', type: 'success'})
                this.$emit('updateDevice')
                this.$emit('change', false)
              })
            }
          } else if (this.isBindType === 3) {
            //  300 310 311 312 313 330 350 351 352 353、手表绑定老人或员工 901、随身通（人）
            if (this.radioType === 1) { // 老人
              if (this.isBind) {
                let data = {
                  did: this.addEditForm.did,
                  pid: this.addEditForm.pid,
                  deviceid: this.addEditForm.deviceid,
                  phone: this.addEditForm.phone
                }
                binddevicetoperson(data).then(res => {
                  this.$notify({title: '成功', message: '成功绑定设备', type: 'success'})
                  this.$emit('updateDevice')
                  this.$emit('change', false)
                })
              } else {
                let data = {
                  id: this.addEditForm.id,
                  phone: this.addEditForm.phone,
                  nonetwork: parseInt(this.addEditForm.nonetwork)
                }
                updatedevicetoperson(data).then(res => {
                  this.$notify({title: '成功', message: '成功编辑设备', type: 'success'})
                  this.$emit('updateDevice')
                  this.$emit('change', false)
                })
              }
            } else if (this.radioType === 2) { // 员工
              if (this.isBind) {
                let data = {
                  did: this.addEditForm.did,
                  orgid: this.addEditForm.orgid,
                  sp_id: this.addEditForm.sp_id,
                  deviceid: this.addEditForm.deviceid,
                  phone: this.addEditForm.phone,
                  auto_patrol: this.addEditForm.auto_patrol
                }
                binddevicenursing(data).then(res => {
                  this.$notify({title: '成功', message: '成功绑定设备', type: 'success'})
                  this.$emit('updateDevice')
                  this.$emit('change', false)
                })
              } else {
                let data = {
                  did: this.addEditForm.did,
                  orgid: this.addEditForm.orgid,
                  sp_id: this.addEditForm.sp_id,
                  deviceid: this.addEditForm.deviceid,
                  phone: this.addEditForm.phone,
                  auto_patrol: this.addEditForm.auto_patrol
                }
                editdevicenursing(data).then(res => {
                  this.$notify({title: '成功', message: '成功编辑设备', type: 'success'})
                  this.$emit('updateDevice')
                  this.$emit('change', false)
                })
              }
            }
          } else if (this.isBindType === 5) { // 员工设备 绑定 850 852平板设备
            if (this.radioType === 2 && this.isBind) { // 暂没有编辑
              let data = {
                did: this.addEditForm.did,
                orgid: this.addEditForm.orgid,
                sp_id: this.addEditForm.sp_id,
                deviceid: this.addEditForm.deviceid,
                phone: this.addEditForm.phone,
                auto_patrol: this.addEditForm.auto_patrol
              }
              binddevicenursing(data).then(res => {
                let send = {
                  'imei': this.addEditForm.deviceid,
                  'did': this.addEditForm.did,
                  'dtype': this.addEditForm.dtype,
                  'orgid': this.addEditForm.orgid,
                  'sys_user_id': this.addEditForm.sys_user_id,
                  'operate_model': '1' // 操作模式护工平板传 1
                }
                binddevicetosysuser(send).then(res => {
                  this.$notify({title: '成功', message: '成功绑定设备', type: 'success'})
                  this.$emit('updateDevice')
                  this.$emit('change', false)
                }).catch(() => {
                  this.$notify.error({
                    title: '失败',
                    message: '绑定设备失败'
                  })
                })
              }).catch(() => {
                this.$notify.error({
                  title: '失败',
                  message: '绑定设备失败'
                })
              })
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditDeviceNew.vue